const state = {
  data: {}
}

const actions = {
  setRouteData ({ commit }, payload) {
    commit('SET_ROUTE_DATA', payload)
  }
}

const mutations = {
  SET_ROUTE_DATA: (state, { path, breadcrumb }) => {
    state.data = {[path]: breadcrumb}
  }
}

const getters = {
  getByPath: state => path => {
    return state.data[path]
  }
}


export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
